import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=62721a4b&scoped=true"
import script from "./CardTitle.vue?vue&type=script&lang=js"
export * from "./CardTitle.vue?vue&type=script&lang=js"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=62721a4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62721a4b",
  null
  
)

export default component.exports